var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ws-w-full ws-h-[225px] ws-bg-no-repeat ws-bg-contain ws-bg-center ws-bg-gray-50",style:(`background-image: ${_vm.backgroundUrl}`),attrs:{"aria-role":"img"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Car image")])])
}
var staticRenderFns = []

export { render, staticRenderFns }